import {createContext} from "react";


export const AdvancedModeContext = createContext(null)